// export const BASE_URL =
//   process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
export const BASE_URL = ''; // If using proxy
export const INPUTS_URL = '/api/inputs';
export const USERS_URL = '/api/users';
export const PRODUCTS_URL = '/api/products';
export const OUTPUTS_URL = '/api/outputs';
export const GRADES_URL = '/api/grades';
